// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function AccountBalanceRow() {
   const state = useQuoteContext()

   if (state.product_list['accountBalance']?.NotInPricebook) {
      return <> </>
   }
   const product = state.product_list['accountBalance']
   const permissions = product?.RoleRequired?.split(',') ?? []
   const hasPermissions =
      permissions.length === 0 || permissions.includes(state.user_role)

   if (hasPermissions || Number(state.accountBalance ?? 0) > 0)
      return (
         <div className='row'>
            <div className='col-bhr1'>{product['ProductName']}</div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='text'
                  placeholder={'0'}
                  disabled={!hasPermissions}
                  // Values can be negative so we just allow an empty string when the value is 0
                  value={
                     state.accountBalance === 0
                        ? ''
                        : state.accountBalance.toString()
                  }
                  onChange={(e) => state.setAccountBalance(e.target.value)}
                  onBlur={() =>
                     state.setAccountBalance(
                        isNaN(
                           Number(state.accountBalance)
                              .toFixed(2)
                              .replace(/\.?0+$/, ''),
                        )
                           ? '0'
                           : Number(state.accountBalance)
                                .toFixed(2)
                                .replace(/\.?0+$/, ''),
                     )
                  }
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.AccountBalanceCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )

   return null
}
